<!-- Theme CSS -->
<link href="/assets/css/style.css" rel="stylesheet">
<link href="/fr/assets/css/style.css" rel="stylesheet">
<link href="/en/assets/css/style.css" rel="stylesheet">
<link href="/es/assets/css/style.css" rel="stylesheet">
<link href="/pt/assets/css/style.css" rel="stylesheet">
<link href="/ko/assets/css/style.css" rel="stylesheet">

<header>
    <nav class="navbar navbar-custom" role="navigation">
      <div class="dropdown">
        <span> <a (click)= "profileIconClick()"><img class="profile_image" src = "./assets/img/user.png"></a></span>
        <div class="dropdown-content">
    <!--       <a class="page-scroll" (click)= "register1Click()" style="cursor: pointer;" i18n>Register</a> -->
          <a class="page-scroll" (click)= "profileClick()" style="cursor: pointer;" i18n>Profile</a>
          <a *ngIf="is_country_fp" class="page-scroll" (click)= "manageTeamClick()" style="cursor: pointer;" i18n>Manage Team</a>
          <a class="page-scroll" (click)= "feedbackClick()" style="cursor: pointer;" i18n>Feedback</a>
          <a class="page-scroll" (click)= "logoutClick()" style="cursor: pointer;" i18n>Logout</a>
        </div>
      </div>
      <lang-change></lang-change>
    </nav>
</header>
<!-- <div class="topbar-logo"> <img src="/assets/img/intro-bg-logo.jpg" class="img-responsive"> </div> -->
<!-- Intro Header -->
<section class="intro landing-high" style="height: 100%;padding-top: 70px;">
    <div class="intro-body intro-body1">
        <div class="container">
            <div class="row" >
                <div class="col-md-12 brand-heading-text">
                    <h5 class="brand-heading" i18n>SDG 6 Policy Support System (SDG-PSS)</h5>
                  <p i18n>SDG-PSS is designed as part of the project <strong>‘​Water in the World We Want​’</strong> to enable government actors and stakeholders to better collaborate to create national-level evidence around SDG 6, its targets and indicators.</p>
                </div>
            </div>
          <div class="row">
                <div class="col-md-2 col-lg-2">
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 login-buttons">
                    <div class="col-xs-12 col-sm-6 col-md-8 btn btn-default btn-radius home-button" style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; " (click)= "introBtnClick()" ><p i18n>Introduction</p></div>
                    <div class="col-xs-12 col-sm-6 col-md-8 btn btn-default btn-radius home-button" style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px;"  (click)= "compBtnClick()" ><p i18n>Components</p></div>
                    <div class="col-xs-12 col-sm-6 col-md-8 btn btn-default btn-radius home-button" style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px;" (click)="viewSummaryBtnClick()" ><p i18n>Summary <br>View</p></div>
                    <div class="col-xs-12 col-sm-6 col-md-8 btn btn-default btn-radius home-button" style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px;" (click)="onlineCourseBtnClick()" ><p i18n>Online <br>course</p></div>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
          </div>
        </div>
    </div>
    <!-- Floating Feedback Button -->
    <button class="floating-feedback-btn" (click)="feedbackClick()" i18n>Feedback</button>
</section>
<!-- About Section -->
<!-- <footer id="about" class="content-section">
  <div class="container">
    <div class="row">
        <div class="col-lg-12">
            <div class="topbar-logo">
                <img src="/assets/img/UNU-INWEH_LOGO.png" class="img-responsive logo">
                <img src="/assets/img/logo1.gif" class="img-responsive logo1">
                <img src="/assets/img/logo2.jpg" class="img-responsive logo1">
                <img src="/assets/img/logo2.png" class="img-responsive logo2">
            </div>
        </div>
    </div>
  <div class="row"><div class="col-lg-12"><p style="padding:30px 0 10px 35px; display:block" i18n>© UNU-INWEH and UNOSD 2017</p></div></div>
    </div>
</footer> -->



// WEBPACK FOOTER //
// ./src/app/home/home.component.html